import type { TFunction } from "i18next";
import {
  ClaimDynamicRewardResultCode,
  type ClaimDynamicRewardResponse,
} from "@/api/types";

/** 领取团队动态奖励失败时的展示文案（优先 resultMsg，其次 i18n） */
export function getClaimDynamicRewardErrorMessage(
  t: TFunction,
  res: Pick<ClaimDynamicRewardResponse, "resultCode" | "resultMsg">
): string {
  const msg = res.resultMsg?.trim();
  if (msg) return msg;

  switch (res.resultCode) {
    case ClaimDynamicRewardResultCode.NothingToClaim:
      return t("teamPage.claimResultCode1");
    case ClaimDynamicRewardResultCode.ReferRewardNotFound:
      return t("teamPage.claimResultCode2");
    case ClaimDynamicRewardResultCode.PendingChanged:
      return t("teamPage.claimResultCode3");
    case ClaimDynamicRewardResultCode.OperationInProgress:
      return t("teamPage.claimResultCode4");
    case ClaimDynamicRewardResultCode.Server:
      return t("teamPage.claimResultCode99");
    default:
      return t("teamPage.claimFailed");
  }
}
